{
  "Cтол": "Стол",
  "Total": "Общее",
  "VIP": "VIP",
  "Адрес": "Адрес",
  "Блюдо готово": "Блюдо готово",
  "Брон": "Бронь",
  "Бронирование": "Бронирование",
  "В процессе": "В процессе",
  "Введите адрес": "Введите адрес",
  "Введите комментария": "Введите комментарии",
  "Введите логин": "Введите логин",
  "Введите пароль": "Введите пароль",
  "Введите сумму": "Введите сумму",
  "Войти": "Войти",
  "Время бронирование": "Время бронирования",
  "время ожидания истекло": "Время ожидания истекло",
  "Всего": "Всего",
  "Вы неможете изменить": "Вы не можете изменить",
  "Вы точно хотите удалить заказ": "Вы точно хотите удалить заказ?",
  "Выберите клиента": "Выберите клиента",
  "Выберите нужные ингредиенты": "Выберите нужные ингредиенты",
  "Выберите официанта": "Выберите официанта",
  "Выберите стол": "Выберите стол",
  "Выход": "Выход",
  "Готов": "Готов",
  "Да": "Да",
  "Дата": "Дата",
  "Дата начало": "Дата начала",
  "Дата окончание": "Дата окончания",
  "Добавить": "Добавить",
  "Добавить клиент": "Добавить клиента",
  "Добро пожаловать!": "Добро пожаловать!",
  "Долг": "Долг",
  "Доставка": "Доставка",
  "Завершенные": "Завершенные",
  "Завершить": "Завершить",
  "Завершить заказ": "Завершить заказ",
  "Заказ": "Заказ",
  "Заказы": "Заказы",
  "Закрыть": "Закрыть",
  "Занято": "Занято",
  "Изменит": "Изменить",
  "Изменить пароль": "Изменить пароль",
  "Имя клиента": "Имя клиента",
  "Клиент": "Клиент",
  "Кол-во": "Кол-во",
  "Комментария": "Комментарии",
  "Комментария повора": "Коментарии повара",
  "Курыерь": "Курьер",
  "Логин": "Логин",
  "На вынос": "На вынос",
  "На данный момент у этого раздела нет заказов": "На данный момент у данного раздела не заказов",
  "На стол": "На стол",
  "Назад": "Назад",
  "Название": "Название",
  "Назначить официанта": "Назначить официанта",
  "Наличные": "Наличные",
  "Нет": "Нет",
  "нет комментарии": "Нет комментариев",
  "Новый": "Новый",
  "Новый пароль": "Новый пароль",
  "Номер": "Номер",
  "Номер заказа": "Номер заказа",
  "Номер клиента": "Номер клиента",
  "Номер курьера": "Номер курьера",
  "Номер стола": "Номер стола",
  "Номер телефона": "Номер телефона",
  "Общий": "Общий",
  "Ожидание клиента": "Ожидание клиента",
  "Онлайн": "Онлайн",
  "Особые пожелания": "Особые пожелания",
  "Отказона от повара": "Отказано поваром",
  "Отмененные": "Отмененные",
  "Отменить": "Отменить",
  "Отправит запрос": "Отправить запрос",
  "Отчет": "Отчет",
  "Официант": "Официант",
  "Пароль": "Пароль",
  "Повторите новый пароль": "Повторите новый пароль",
  "Повторный пароль не совподаеть": "Повторный пароль не совпадает",
  "Пожалуйста, войдите, используя свою учетную запись": "Пожалуйста, войдите используя свою учетную запись",
  "Причина отклонение": "Причина отклонения",
  "Продукты": "Продукты",
  "Создат": "Создать",
  "Создать заказ": "Создать заказ",
  "Сохранит": "Сохранить",
  "Сохранить": "Сохранить",
  "Список заказов": "Список заказов",
  "Статус": "Статус",
  "Статус заказа": "Статус заказа",
  "Стол": "Стол",
  "сум": "сумов",
  "Сумма доставки": "Сумма доставки",
  "Сумма обслугу": "Сумма обслуживания",
  "Сумма продуктов": "Сумма продуктов",
  "Сформировать": "Сформировать",
  "Терминал": "Терминал",
  "Тип": "Тип",
  "Тип заказа": "Тип заказа",
  "Тип оплата": "Тип оплаты",
  "Удалить заказ": "Удалить заказ",
  "Успешно удалено": "Успешно удалено",
  "Фильтровать": "Фильтровать",
  "Фото": "Фото",
  "Цена": "Цена",
  "Цена за единицу": "Цена за единицу",
  "что-то пошла не так!": "Что-то пошло не так!"
}
